export const RECEIVED_CART = "received_cart";
export const TEMP_CART_UPDATED = "temp_cart_updated";
export const TEMP_CART_KIT_UPDATED = "temp_cart_kit_updated";
export const TEMP_WIRELESS_PLAN_UPDATED = "temp_wireless_plan_updated";
export const CART_UPDATED = "cart_updated";
export const CART_CLEARED = "cart_cleared";